/**
 * @fileoverview This file contains the how to download section.
 */
import { Step } from "../components/Step";
import { Link } from "react-router-dom";
import HowToDownload1 from "./img/HowToDownload1.png";
import HowToDownload2 from "./img/HowToDownload2.png";
import HowToDownload3 from "./img/HowToDownload3.png";
import HowToDownload4 from "./img/HowToDownload4.png";
import HowToDownload5 from "./img/HowToDownload5.png";

const steps_download = [
  {
    step: "1.",
    text: "「ダウンロード」をクリックすると、ダウンロードを開始します。または，右クリックして「名前を付けてリンク先を保存…」を押し，任意の場所を選択してください。",
    image: HowToDownload1,
    alt: "サイトのダウンロード画面",
  },

  {
    step: "2.",
    text: "ダウンロードが完了すると，以下の画面が表示されます。[フォルダーに表示]ボタンをクリックしてください。",
    image: HowToDownload2,
    alt: "ダウンロード完了画面",
  },

  {
    step: "3.",
    text: "ダウンロードした「GasLogReader.zip」を右クリックして「すべて展開…」を選択してください",
    image: HowToDownload3,
    alt: "zipファイルをすべて展開",
  },

  {
    step: "4.",
    text: "GasLogReaderを置きたい場所を選んで「展開」を押してください。",
    image: HowToDownload4,
    alt: "zipファイル展開画面",
  },

  {
    step: "5.",
    text: (
      <>
        展開が完了すると，「CDM212364_Setup.exe」と「GasLogReader.exe」が表示されます。ダウンロード終了後は、
        <Link to="/gas-log-reader/HowToInstallDeviceDriver">
          デバイスドライバーのインストール
        </Link>
        を参考にして、ドライバーソフトウェアをインストールしてください。
      </>
    ),
    image: HowToDownload5,
    alt: "完了",
  },
];

/**
 * How to download
 * @returns {JSX.Element} ダウンロード方法の JSX element
 */
export function HowToDownload(): JSX.Element {
  return (
    <>
      <p className="c-text">
        GasLogReaderと，デバイスドライバーのインストーラーのダウンロード手順をお知らせします。
      </p>
      <section className="c-section">
        <h2 className="p-heading-2">ダウンロード手順</h2>
        {steps_download.map((step, index) => (
          <Step
            key={index}
            step={step.step}
            text={step.text}
            image={step.image}
          />
        ))}
      </section>
    </>
  );
}
